'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M38.824 21c0 10.494-8.507 19-19 19s-19-8.506-19-19 8.507-19 19-19 19 8.506 19 19",
    fill: "currentColor",
    opacity: 0.3
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M33.798 18.828H13.121v30.277h20.677z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M33.798 18.828H13.121v30.277h20.677V18.828Zm-1.478 1.477v27.323H14.597V20.305H32.32Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#E9EAE6",
    d: "M16.075 19.567h14.77v-3.693h-14.77z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M31.583 15.136H15.336v5.169h16.247v-5.17Zm-1.478 1.477v2.215H16.813v-2.215h13.292Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#FFF",
    d: "M21.983 48.367h4.43v-5.908h-4.43z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M27.152 41.72h-5.908v7.385h5.908V41.72Zm-1.478 1.477v4.431H22.72v-4.43h2.954ZM21.983 25.474h-5.17v5.17h5.17v-5.17Zm-1.478 1.477v2.216H18.29V26.95h2.215ZM21.983 31.382h-5.17v5.17h5.17v-5.17Zm-1.478 1.477v2.215H18.29V32.86h2.215Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M14.598 29.167H5.736v19.938h8.862z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M13.12 30.643v16.985H7.213V30.643h5.907Zm1.478-1.476H5.736v19.938h8.862V29.167Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#E9EAE6",
    d: "M8.69 29.905h5.17v-3.692H8.69z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M14.598 25.474H7.952v5.17h6.646v-5.17Zm-1.478 1.477v2.216H9.428V26.95h3.692Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M33.113 24.736a8.069 8.069 0 0 0-8.068 8.069c0 6.964 6.881 7.906 7.46 14.986a.616.616 0 0 0 .608.576.617.617 0 0 0 .61-.576c.579-7.08 7.46-8.022 7.46-14.986a8.069 8.069 0 0 0-8.07-8.07",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M33.113 23.997a8.807 8.807 0 0 0-8.806 8.808c0 3.103.92 4.818 3.566 7.79l.608.678c2.18 2.438 3.08 4.037 3.287 6.578a1.354 1.354 0 0 0 1.345 1.254c.712 0 1.288-.55 1.346-1.254.208-2.541 1.109-4.14 3.29-6.579l.376-.419c2.823-3.133 3.796-4.857 3.796-8.048a8.807 8.807 0 0 0-8.808-8.808Zm0 1.477a7.33 7.33 0 0 1 7.331 7.331c0 2.259-.562 3.641-2.233 5.69l-.362.433-.394.456-.21.237-.597.665-.226.255c-1.844 2.1-2.837 3.719-3.252 5.837l-.057.314-.007-.046c-.397-2.338-1.457-4.044-3.525-6.358l-.38-.422a47.788 47.788 0 0 1-.63-.712l-.377-.445c-1.809-2.168-2.41-3.567-2.41-5.904a7.33 7.33 0 0 1 7.33-7.33Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M36.013 32.859a2.954 2.954 0 1 1-5.908 0 2.954 2.954 0 0 1 5.908 0",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M33.06 29.167a3.692 3.692 0 1 0 0 7.384 3.692 3.692 0 0 0 0-7.384Zm0 1.476a2.216 2.216 0 1 1 0 4.432 2.216 2.216 0 0 1 0-4.432ZM9.429 11.874v1.477h-5.17v-1.477h5.17Zm2.954 0v1.477h-1.477v-1.477h1.477Zm28.39-5.448c1.245 0 2.369.542 3.096 1.468l.034.044.048-.001c1.266-.024 2.251.485 2.845 1.59l.067.132h1.704v1.477h-2.722l-.172-.498c-.333-.963-.908-1.301-1.914-1.213l-.14.014-.483.059-.244-.421c-.426-.733-1.208-1.174-2.12-1.174-1.471 0-2.384.794-2.453 2.337l-.005.162-.004.734h-3.774V9.659h2.356l.025-.151c.34-1.894 1.75-3.017 3.684-3.08l.172-.002Zm-25.011-4.46c1.754 0 3.338.995 4.178 2.5l.027.05.12-.02c.066-.01.134-.017.201-.022l.203-.007c1.023 0 1.998.562 2.616 1.36l.102.14h4.681v1.476h-5.548l-.205-.402c-.312-.61-1-1.097-1.646-1.097-.164 0-.336.03-.518.09l-.138.05-.7.28-.265-.706c-.492-1.31-1.734-2.215-3.108-2.215-1.54 0-3.22 1.815-3.318 3.148l-.004.116-.003.736h-6.7V5.967h5.315l.028-.113c.492-1.863 2.46-3.79 4.523-3.885l.159-.003Zm15.082 4v1.477h-1.477V5.967h1.477Zm2.954 0v1.477h-1.477V5.967h1.477ZM2.783 47.5v1.477H1.306V47.5h1.477Zm42.477 0v1.477h-2.954V47.5h2.954Zm-3.704 0V49h-9v-1.5h9Zm7.227 0v1.477h-1.477V47.5h1.477Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  })));
});
var RealtyFlat = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.RealtyFlat = RealtyFlat;